export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";